import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted, play } from "@/lib/sound";

export default function SoundToggle({ className = "" }) {
  const [muted, setMutedState] = useState(isMuted());

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
    if (!next) play("pop");
  };

  return (
    <button
      data-testid="sound-toggle"
      onClick={toggle}
      aria-label={muted ? "Unmute sounds" : "Mute sounds"}
      className={`w-9 h-9 rounded-full glass flex items-center justify-center ${className}`}
    >
      {muted ? (
        <VolumeX className="w-4 h-4 text-[#4a5c62]" strokeWidth={1.5} />
      ) : (
        <Volume2 className="w-4 h-4 text-[#16242a]" strokeWidth={1.5} />
      )}
    </button>
  );
}
